export default __webpack_public_path__ + "images/auction.svg?9fe619b915f2899385ecc59f1c21eb66";